import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-current-learning-path-status-widget-demo',
    templateUrl: './current-learning-path-status-widget-demo.component.html',
    styleUrl: './current-learning-path-status-widget-demo.component.scss',
    standalone: false
})
export class CurrentLearningPathStatusWidgetDemoComponent {
  rawData = [
    { id: 1, name: 'Onboarding', completedCourses: 2, openCourses: 3 },
    { id: 2, name: 'Security', completedCourses: 5, openCourses: 0 },
  ];

  learningPathsProgressData = this.rawData.map(item => {
    const total = item.completedCourses + item.openCourses;
    const percentage = total > 0 ? Math.round((item.completedCourses / total) * 100) : 0;
    return {
      id: item.id,
      name: item.name,
      progress: `${item.completedCourses} / ${total}`,
      progressPercentage: percentage,
    };
  });

  learningPathsProgressColumns = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.NAME'),
      dataField: 'name',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS'),
      dataField: 'progress',
    }
  ];

  constructor(private translateService: TranslateService) {}
}
